import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { accessInputFromRedux } from '@/abilities/accessInput';
import { useAccessInputFromQuery } from '@/abilities/useAccessInputFromQuery';
import { companySettingsAccess } from '@/abilities/companySettings/access';
import { currentCompanyIdSelector } from '@/domain/router/routerLeafSelectors';
import { companyRoleSelector } from '@/domain/env/sessionRoleSelectors';
import { isAdminSelector } from '@/domain/env/envSelector';
import { useCompanyCapabilities } from '@/domain/companies/queries/capabilities';
import { useErpConnections } from '@/domain/erpIntegration/queries/connections';
import { useCompanyUserPreferences } from '@/domain/env/queries/companyUserPreferences';

export const useCompanySettingsAccess = () => {
  const companyId = useSelector(currentCompanyIdSelector);
  const role = useSelector(companyRoleSelector);
  const isAdmin = useSelector(isAdminSelector);
  const capabilities = useAccessInputFromQuery(useCompanyCapabilities(companyId));
  const erpConnections = useAccessInputFromQuery(useErpConnections(companyId));
  const bankFeedUserPermissions = useAccessInputFromQuery(useCompanyUserPreferences(companyId));
  return useMemo(
    () =>
      companySettingsAccess({
        role: accessInputFromRedux(role),
        isAdmin: accessInputFromRedux(isAdmin),
        capabilities,
        erpConnections,
        bankFeedUserPermissions,
      }),
    [role, isAdmin, capabilities, erpConnections, bankFeedUserPermissions],
  );
};
